import i from "./highrise1343.mjs";
import e from "./highrise1063.mjs";
import f from "./highrise1344.mjs";
import n from "./highrise1345.mjs";
import a from "./highrise1346.mjs";
import p from "./highrise1342.mjs";
import s from "./highrise1347.mjs";
var u = 1, A = 2;
function y(r, o) {
  return n(r) && a(o) ? p(s(r), o) : function(m) {
    var t = e(m, r);
    return t === void 0 && t === o ? f(m, r) : i(o, t, u | A);
  };
}
export {
  y as default
};
